var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"highlight title"},[_c('ogt-video',{ref:"video",attrs:{"src":"/static/video/highlight.mp4","poster":"/static/video/highlight-poster.jpg"}}),_vm._v(" "),_c('h1',{staticClass:"bigger"},[_vm._v("Highlights 2020")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }